import React, { lazy } from 'react';
import { useLoginState } from '../../utilities/hooks/useLoginState';
import { useLoginPageViewed } from './hooks/useLoginPageViewed';
import { LoginTooManyAttemptsRecaptchaContextProvider } from './contexts/LoginTooManyAttemptsRecaptchaContext';
import { LoginRecoveryOptionsContextProvider } from './contexts/LoginRecoveryOptionsContext';
import { LoginGoogleOneTapRenderBoundary } from './components/LoginGoogleOneTap';
import { MarketingConsentContextProvider } from './contexts/LoginMarketingConsentContext';
import { useShouldOrchestrate } from '../orchestrator';

import OrchestratedLoginPage from './OrchestratedPage';
import { useSearchParamCodes } from './hooks/utility';
import { RecaptchaContextProvider } from '../../contexts/recaptcha';
import { loginPageId } from './constants';
import { usePageStateLoader } from '../../utilities/hooks/useGlobalPageState';

const BasePage = lazy(() => import('./BasePage'));

const LoginPage = () => {
  usePageStateLoader();
  useLoginPageViewed();
  const shouldOrchestrate = useShouldOrchestrate();

  const { state } = useLoginState();

  const { errorCode } = useSearchParamCodes();

  const error = state?.login?.error || errorCode;
  const recaptchaType = error?.code === 'captchaScoreTooLow' ? 'checkbox' : 'score';

  return (
    <LoginTooManyAttemptsRecaptchaContextProvider>
      <LoginRecoveryOptionsContextProvider>
        <LoginGoogleOneTapRenderBoundary>
          <MarketingConsentContextProvider>
            <RecaptchaContextProvider
              pageId={loginPageId}
              action="checkUsername"
              type={recaptchaType}>
              {shouldOrchestrate ? <OrchestratedLoginPage /> : <BasePage />}
            </RecaptchaContextProvider>
          </MarketingConsentContextProvider>
        </LoginGoogleOneTapRenderBoundary>
      </LoginRecoveryOptionsContextProvider>
    </LoginTooManyAttemptsRecaptchaContextProvider>
  );
};

export default LoginPage;
